import { ISite } from '@/api';

export class Site {

    public static fromDto(siteDto: ISite): Site {
        return new Site(siteDto.id, siteDto.name || siteDto.id);
    }

    public id: string;
    public name: string;

    constructor(
        id: string,
        name: string,
    ) {
        this.id = id;
        this.name = name;
    }
}
